module.exports = __webpack_public_path__ + "img/banner4.498981f3.jpg";